import React from "react";

import moment from "moment";

import { withRouter } from "react-router-dom";

import LocationFormat from "../../../../utils/LocationFormat";
import BaseTable from "../BaseTable";
import General from "../../../../utils/General";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Notify from "../../../../utils/Notify";

class CancelledOrdersTable extends React.Component {
  constructor(props) {
    super(props);

    // this.state = {};
    this.state = {
      data: [],
      exporting: false,
    };
    this.table = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _renderAddress(address) {
    return (
      <span className="text-dark-75 font-weight-bold line-height-sm">
        {address ? LocationFormat.fullAddress(address) : "-"}
      </span>
    );
  }

  exportXLSX = () => {
  const rows = this.state.data || [];

  if (rows.length === 0) {
    return Notify.error("No cancelled orders to export");
  }

  const sheetData = rows.map((order) => {
    const customerName = order?.customer?.user
      ? `${order.customer.user.first_name || ""} ${order.customer.user.last_name || ""}`.trim()
      : "-";

    const venueName = order?.venue?.company?.title || "-";
    const branchName = order?.venue?.title || "-";

    const items = order?.data?.items || [];

    const products = items
      .map((orderItem) => orderItem?.item?.title || "-")
      .join(" | ");

    const customerAddress = order?.data?.customer_address || {};

    const fullAddress = [
      customerAddress.line_1,
      customerAddress.line_2,
      customerAddress.city,
      customerAddress.state,
      customerAddress.postal_code,
    ]
      .filter(Boolean)
      .join(", ");

    return {
      "Order ID": order?.id || "-",
      "Cancelled By": venueName,
      "Venue / Branch": branchName,
      "Customer Name": customerName,
      "Customer Email": order?.customer?.user?.email || "-",
      "Customer Phone": order?.customer?.user?.phone_number || "-",
      "Customer Address": fullAddress || "-",
      "Products": products || "-",
      "Order Status": order?.status || "-",
      "Rejection Reason": order?.rejection_reason || "-",
      "Created At": order?.created_at
        ? moment(order.created_at).format("DD MMM YYYY - hh:mm A")
        : "-",
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Cancelled Orders");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `cancelled_orders_export_${Date.now()}.xlsx`);
};

  _getColumns() {
    return [
      {
        Header: () => <strong className="header__clr"></strong>,
        id: "id",
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let orderId = order.id;

          let itemImage = "";

          if (order?.data?.items.length === 1) {
            itemImage = order?.data?.items?.map(
              (orderItem) => orderItem?.item?.image?.original
            );
          } else {
            itemImage = order?.data?.items[0]?.item?.image?.original;
          }

          return (
            <>
              <span style={{ width: 278 }}>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-40 flex-shrink-0">
                    {itemImage ? (
                      <div
                        className="symbol-label"
                        style={{
                          backgroundImage: `url(${itemImage})`,
                        }}
                      ></div>
                    ) : (
                      <div
                        className="symbol-label"
                        style={{
                          backgroundColor: "whitesmoke",
                          width: 40,
                          height: 40,
                          borderRadius: "10%",
                        }}
                      />
                    )}
                  </div>
                  <div className="ml-2">
                    <div className="text-dark-75 font-weight-bold line-height-sm">
                      Order #{orderId}
                    </div>{" "}
                    <a
                      href="javascript:;"
                      className="font-size-sm text-dark-50 text-hover-primary"
                    >
                      Cancelled by: {order?.venue?.company?.title}{" "}
                    </a>
                    <span> - {order?.venue?.title} </span>
                  </div>
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr"></strong>,
        id: "customer.user.first_name",
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let customer = "";

          if (order?.customer?.user) {
            customer = `${General.toTitleCase(
              order?.customer?.user?.first_name
            )} ${General.toTitleCase(order?.customer?.user?.last_name)}`;
          } else {
            customer = "-";
          }

          return (
            <div className="d-flex align-items-center">
              <div className="ml-2">
                {" "}
                <a
                  href="javascript:;"
                  className="font-size-sm text-dark-50 text-hover-primary"
                >
                  Customer{" "}
                </a>
                <div className="text-dark-75 font-weight-bold line-height-sm">
                  {customer}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: () => <strong className="header__clr"></strong>,
        id: "created_at",
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let createdAt = `${moment(order?.created_at).format(
            "DD MMM YYYY - hh:mm A"
          )}`;

          if (!order?.created_at) {
            return "-";
          }

          return (
            <>
              <div className="d-flex align-items-center">
                <div className="ml-2">
                  {" "}
                  <a
                    href="javascript:;"
                    className="font-size-sm text-dark-50 text-hover-primary"
                  >
                    Order created at{" "}
                  </a>
                  <div className="text-dark-75 font-weight-bold line-height-sm">
                    {createdAt}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
    ];
  }

  render() {
    const { isLoading } = this.state;

    const columns = this._getColumns();

    let tableProps = {};

    return (
      <>

      <div className="d-flex justify-content-end mb-4">
  <button
    onClick={this.exportXLSX}
    className="btn btn-primary font-weight-bolder"
    style={{
      background: "#73113b",
      border: "#73113b",
      color: "white",
    }}
  >
    Export XLSX
  </button>
</div>

        <BaseTable
          {...tableProps}
          ref={this.table}
          title={this.props.title}
          loading={isLoading}
          endpoint={`${window.Api.Orders}?statuses=rejected&rejection_reason=rejected_by_venue`}
          noDataMessage={"No cancelled orders found"}
          onDataLoaded={(data) => {
            this.setState({ data });
          }}
          columns={columns}
          showPagination={true}
          showSearch={true}
          defaultSorted={[
            {
              id: "created_at",
              desc: true,
            },
          ]}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                paddingLeft: 10,
                overflow: column.Header === "Actions" ? "visible" : "hidden",
              },
            };
          }}
        />
      </>
    );
  }
}

CancelledOrdersTable.defaultProps = {
  title: "Cancelled Orders",
  showPagination: true,
  showPaginationTop: true,
  showPaginationBottom: true,
};

export default withRouter(CancelledOrdersTable);
